<div #questionPage></div>
<div class="hygiene-check-form" [formGroup]="form">
    <div formArrayName="questions">
        <div *ngFor="let questionControl of questionsArray.controls; let i = index">
            <ng-container *ngIf="questions[i].isCaption">
                <div class="title-tab-container">{{ questions[i].statement | translate }}</div>
            </ng-container>

            <ng-container *ngIf="!questions[i].isCaption">
                <div class="hygiene-article" [formGroupName]="i">
                    <div class="article-header">
                        <lib-html-text [text]="questions[i].statement"></lib-html-text>
                        <div class="btn-info-question">
                            <button class='btn-only-icon btn-initial btn-question-info' type='button'
                                *ngIf="showInfoButton(questions[i])" (click)="onClickQuestionInfo(questions[i])"><img
                                    src='assets/icons/infoOutlined.svg' /></button>
                        </div>
                    </div>

                    <div class="description"
                        *ngIf="questions[i].min != null && questions[i].max != null && questions[i].referenceDesc && questions[i].referenceDesc.length > 0">
                        <p class="referenceDesc">{{ questions[i].referenceDesc }}</p>
                    </div>

                    <div class="article-options" [ngClass]="getOptionsDisplay(questions[i])">
                        <ng-container *ngIf="questions[i].isOldVersion">
                            <div *ngFor="let answer of questions[i].userAnswers; let j = index" class="input-radio">
                                <input type="radio" formControlName="answer" [value]="answer.id" [id]="'question-'+i+j"
                                    (click)="selectInput(answer, i, questions[i] )">
                                <label [for]="'question-'+i+j">{{ getStatementText(answer.statement) | translate }}</label>
                            </div>
        
                            <div class="input-radio d-none">
                                <input type="radio" formControlName="answer" value="undefined">
                            </div>
                        </ng-container>
                        <ng-container *ngIf="isInputQuestion(questions[i])">
                            <label class="input-floating w-25">
                                <input formControlName="answer" *ngIf="isNumericalInput(questions[i])" type="number"
                                    class="form-input numeric-input"
                                    placeholder="{{ 'CHECK.QUESTIONNAIRE.ENTER_NUMBER' | translate }}"
                                    (change)="onInputAnswerChange($event, questions[i], i)" />
                                <input formControlName="answer" *ngIf="!isNumericalInput(questions[i])" type="text"
                                    class="form-input text-input"
                                    placeholder="{{ 'CHECK.QUESTIONNAIRE.ENTER_TEXT' | translate }}"
                                    [(change)="onInputAnswerChange($event, questions[i], i)" />
                                <span>{{ (isNumericalInput(questions[i]) ? 'CHECK.QUESTIONNAIRE.ENTER_NUMBER' :
                                    'CHECK.QUESTIONNAIRE.ENTER_TEXT') | translate }}</span>
                            </label>
                        </ng-container>

                        <ng-container *ngIf="checkOrRadio(questions[i])">
                            <ng-container *ngIf="questions[i].captionPosition === 'Top'">
                                <div *ngFor="let answer of questions[i].userAnswers; let j = index" class="input-radio vertical-caption">
                                    <label class="answer-text" [for]="'question-'+i+j">{{ getStatementText(answer.statement) | translate }}</label>
                                    <div class="input">
                                        <input type="radio" formControlName="answer" [value]="answer.id" [ngClass]="getInputSkin(questions[i]?.skin)"
                                        [id]="'question-'+i+j" (click)="selectInput(answer, i, questions[i] )">
                                        <label class="vertical-label" [ngClass]="getInputLabelSkin(questions[i], answer)" [for]="'question-'+i+j">&nbsp;</label>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="questions[i].captionPosition === 'Bottom'">
                                <div *ngFor="let answer of questions[i].userAnswers; let j = index" class="input-radio vertical-caption">
                                    <div class="input">
                                        <input [type]="questions[i]?.skin == 'Radio' ? 'radio' : 'checkbox'" formControlName="answer" [value]="answer.id" [ngClass]="getInputSkin(questions[i]?.skin)"
                                            [id]="'question-'+i+j" (click)="selectInput(answer, i, questions[i] )">
                                        <label class="vertical-label" [ngClass]="getInputLabelSkin(questions[i], answer)" [for]="'question-'+i+j">&nbsp;</label>
                                    </div>
                                    <label class="answer-text" [for]="'question-'+i+j">{{ getStatementText(answer.statement) | translate }}</label>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="questions[i].captionPosition === 'Right'">
                                <div *ngFor="let answer of questions[i].userAnswers; let j = index" class="input-radio">
                                    <input [type]="questions[i]?.skin == 'Radio' ? 'radio' : 'checkbox'" formControlName="answer" [value]="answer.id" [ngClass]="getInputSkin(questions[i]?.skin)"
                                            [id]="'question-'+i+j" (click)="selectInput(answer, i, questions[i] )">
                                    <label [ngClass]="getInputLabelSkin(questions[i], answer)" [for]="'question-'+i+j">{{ getStatementText(answer.statement) | translate }}
                                    </label>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="questions[i].captionPosition === 'Left'">
                                <div *ngFor="let answer of questions[i].userAnswers; let j = index" class="input-radio left-caption">
                                    <div class="input">
                                        <input [type]="questions[i]?.skin == 'Radio' ? 'radio' : 'checkbox'" formControlName="answer" [value]="answer.id" [ngClass]="getInputSkin(questions[i]?.skin)"
                                            [id]="'question-'+i+j" (click)="selectInput(answer, i, questions[i] )">
                                        <label class="left-label" [ngClass]="getInputLabelSkin(questions[i], answer)" [for]="'question-'+i+j">&nbsp;</label>
                                    </div>
                                    <label class="answer-text" [for]="'question-'+i+j">{{ getStatementText(answer.statement) | translate }}</label>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="questions[i].captionPosition === 'None'">
                                <div class="answer-box" *ngFor="let answer of questions[i].userAnswers; let j = index">
                                    <div class="input">
                                        <input [type]="questions[i]?.skin == 'Radio' ? 'radio' : 'checkbox'" formControlName="answer" [value]="answer.id" [ngClass]="getInputSkin(questions[i]?.skin)"
                                            [id]="'question-'+i+j" (click)="selectInput(answer, i, questions[i] )">
                                        <label *ngIf="questions[i].skin != 'Star'" [ngClass]="getInputLabelSkin(questions[i], answer)" [for]="'question-'+i+j">&nbsp;</label>
                                        <label class="label-star" *ngIf="questions[i].skin === 'Star'" [ngClass]="getInputLabelSkin(questions[i], answer)" [for]="'question-'+i+j"></label>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="input-radio d-none">
                                <input [type]="questions[i]?.skin == 'Radio' ? 'radio' : 'checkbox'" formControlName="answer" value="undefined">
                            </div>
                        </ng-container>
                        <ng-container *ngIf="questions[i]?.skin == 'Star'">
                            <div class="answer-box" *ngFor="let answer of questions[i].userAnswers; let j = index">
                                <div class="input">
                                    <input type="radio" class="d-none" formControlName="answer" [value]="answer.id" 
                                        [id]="'question-'+i+j" (click)="selectInput(answer, i, questions[i] )">
                                    <label class="label-star" [ngClass]="starSelected(questions[i], j) ? 'active-star' : 'inactive-star'" [for]="'question-'+i+j"></label>
                                </div>
                            </div>
                            <div class="input-radio d-none">
                                <input [type]="questions[i]?.skin == 'Radio' ? 'radio' : 'checkbox'" formControlName="answer" value="undefined">
                            </div>
                        </ng-container>
                        
                    </div>

                    <div class="article-comment">
                        <label class="input-floating" [ngClass]="!editable ? 'no-border-bottom' : ''">
                            <textarea #textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3" type="text" class="form-input"
                                formControlName="comment" [placeholder]="'CHECK.COMMENT' | translate"
                                (keyup)="autoGrowTextZone($event)" (focusout)="onFocusOutTextareaEvent(questions[i], i)"
                                (click)="clickTextarea()"></textarea>
                            <span>{{ 'CHECK.COMMENT' | translate }}</span>
                        </label>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<lib-inspection-offcanvas [isCollapsed]="isCollapsed" (childData)="onchildData($event)"
    [additionalInfoData]="getAdditionalInfo()"></lib-inspection-offcanvas>
